<template>
     <base-section id="theme-features-images">
          <base-section-heading title="Theme Features">
               Lorem ipsum dolor sit amet consectetur adipisicing elit. Libero,
               in! Asperiores, impedit libero. Veniam rerum saepe unde nihil
               possimus quibusdam esse accusamus mollitia magni fuga.
          </base-section-heading>

          <v-responsive max-width="1600" class="mx-auto">
               <v-container fluid>
                    <v-row>
                         <v-col cols="12" md="3" sm="3">
                              <base-image-card
                                   :image="
                                        require('@/assets/images/placeholder.gif')
                                   "
                                   title="PIXEL PERFECT DESIGN"
                                   text="Lorem ipsum dolor sit amet consectetur adipisicing elit. Libero,
                                in! Asperiores, impedit libero. Veniam rerum saepe unde nihil
                                possimus quibusdam esse accusamus mollitia magni fuga."
                              ></base-image-card>
                         </v-col>
                         <v-col cols="12" md="3" sm="3">
                              <base-image-card
                                   :image="
                                        require('@/assets/images/placeholder.gif')
                                   "
                                   title="RETINA READY"
                                   text="Lorem ipsum dolor sit amet consectetur adipisicing elit. Libero,
                                in! Asperiores, impedit libero. Veniam rerum saepe unde nihil
                                possimus quibusdam esse accusamus mollitia magni fuga."
                              ></base-image-card>
                         </v-col>
                         <v-col cols="12" md="3" sm="3">
                              <base-image-card
                                   :image="
                                        require('@/assets/images/placeholder.gif')
                                   "
                                   title="EASILY CUSTOMIZABLE"
                                   text="Lorem ipsum dolor sit amet consectetur adipisicing elit. Libero,
                                in! Asperiores, impedit libero. Veniam rerum saepe unde nihil
                                possimus quibusdam esse accusamus mollitia magni fuga."
                              ></base-image-card>
                         </v-col>
                         <v-col cols="12" md="3" sm="3">
                              <base-image-card
                                   :image="
                                        require('@/assets/images/placeholder.gif')
                                   "
                                   title="SEO OPTIMIZED"
                                   text="Lorem ipsum dolor sit amet consectetur adipisicing elit. Libero,
                                in! Asperiores, impedit libero. Veniam rerum saepe unde nihil
                                possimus quibusdam esse accusamus mollitia magni fuga."
                              ></base-image-card>
                         </v-col>
                    </v-row>
               </v-container>
          </v-responsive>
     </base-section>
</template>

<script>
export default {
     name: 'SectionThemeFeatures',

     data: () => ({
          features: [
               {
                    title: 'Pixel Perfect Design',
                    icon: 'mdi-fountain-pen-tip',
               },
               {
                    title: 'Retina Ready',
                    icon: 'mdi-cellphone',
               },
               {
                    color: 'primary',
                    dark: true,
                    title: 'Easily Customizable',
                    icon: 'mdi-pencil-box-outline',
               },
               {
                    title: 'Image Parallax',
                    icon: 'mdi-image-size-select-actual',
               },
               {
                    title: 'Seo Optimized',
                    icon: 'mdi-ice-pop',
               },
               {
                    title: '24/7 Support',
                    icon: 'mdi-help-circle-outline',
               },
          ],
     }),
}
</script>
